import angular from 'angular';
import FetchReactDataFactory from './fetch-react-data.factory';


let fetchReactDataModule = angular.module('fetchReactData', [])

    .factory('FetchReactData', FetchReactDataFactory)

    .name;

export default fetchReactDataModule;



// WEBPACK FOOTER //
// ./client/app/common/fetch-react-data/index.js